module.exports = __webpack_public_path__ + "img/WebAlertSmall.e818327d.svg";